module.exports = __webpack_public_path__ + "static/images/cover_D4.da1d026.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_D4.png
// module id = oCaR
// module chunks = 8